<div class="links">
  <div>
    <a [routerLink]="['/cookie-policy']" aria-label="Cookie Settings">
      <ng-container i18n>Cookie Settings</ng-container>
    </a>
  </div>
  <div>
    <a [routerLink]="['/terms-of-service']" aria-label="Terms of Use">
      <ng-container i18n>Terms of Use</ng-container>
    </a>
  </div>
  <div>
    <a [routerLink]="['/privacy-policy']" aria-label="Privacy Policy">
      <ng-container i18n>Privacy Policy</ng-container>
    </a>
  </div>
  <div>
    <a [routerLink]="['/sitemap']" aria-label="Sitemap">
      <ng-container i18n>Sitemap</ng-container>
    </a>
  </div>
</div>

<div class="socials">
  <a class="social" [href]="instagramUrl" target="_blank" aria-label="Visit HostelHop on Instagram">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/instagram.svg"></svg-icon>
  </a>
  <a class="social" [href]="facebookUrl" target="_blank" aria-label="Visit HostelHop on Facebook">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/facebook.svg"></svg-icon>
  </a>
  <a class="social" [href]="tiktokUrl" target="_blank" aria-label="Visit HostelHop on Instagram">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/tiktok.svg"></svg-icon>
  </a>
  <!-- <a class="social" [href]="twitterUrl">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/twitter.svg"></svg-icon>
  </a> -->
</div>
